import React from "react";
import 'shaka-player/dist/controls.css';
import './ShakaPlayer.css';
import {GAevent} from "../../../api-client/core/authentication/utils";
import {get} from 'lodash';
import {request} from "../../../api-client";
import {isNullOrUndefined} from "util";
import {isIOSDevice, isMobileDevice, makeSubtitlesLabel} from "../../../utils";
import moment from "moment";

const shaka = require('shaka-player/dist/shaka-player.ui.js');

class ShakaPlayer extends React.PureComponent{

  constructor(props) {
    super(props);
    this.state = {
      trackedPlay: false,
      autoPlay: isMobileDevice() ? false : props.autoPlay,
      preRollVideo: props.preRollVideo,
      closed: false
    }

    this.preRollVideoRef = React.createRef();
    this.preRollVideoContainerRef = React.createRef();

    this.videoRef = React.createRef();
    this.videoContainerRef = React.createRef();

    this.onErrorEvent = this.onErrorEvent.bind(this);
    this.onError = this.onError.bind(this);

    this.castReceiverId = process.env.REACT_APP_CAST_RECEIVER_ID || "930DEB06";
    this.castProxy = null;

    this.player = null;
    this.ui = null;
  }

  componentDidMount = async () => {
    this.pauseBanners()

    const {preRollVideo, video} = this.props;

    if (preRollVideo) {
      await this.initPlayer({
        video: preRollVideo,
        isPreRoll: true,
        videoRef: this.preRollVideoRef,
        videoContainerRef: this.preRollVideoContainerRef
      });
    } else {
      await this.initPlayer({video});

      const castProxy = this.castProxy;
      try {
        if (castProxy && castProxy.isCasting()) {
          castProxy.cast();
        }
      } catch (error) {
        this.onError(error);
      }
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.player) {
      this.player.destroy();
    }
  }

  pauseBanners = () => {
    const bannerVideo = document.getElementById('banner-video');
    if (bannerVideo) {
      bannerVideo.pause();
    }
  }

  onError = (error) => console.error('Error code', error.code, 'object', error);

  onErrorEvent = (event) => this.onError(event.detail);

  initPlayer = async ({
    video,
    isPreRoll = false,
    videoRef = this.videoRef,
    videoContainerRef = this.videoContainerRef
  }) => {
    shaka.polyfill.installAll();

    let player = new shaka.Player(videoRef);

    player.configure({
      streaming: {
        alwaysStreamText: true,
        bufferingGoal: 30
      }
    });

    //DRM
    if (video.drm) {
      let drm = get(video, 'drm');

      const expiredAt = moment(get(video, 'drm.expires_at'));
      const playedAt = moment();

      if (playedAt.isAfter(expiredAt)) {
        const {reloadDrm} = this.props;
        if (reloadDrm) {
          drm = await reloadDrm();
        } else {
          window.location.reload(false);
        }
      }

      player.configure({
        drm: {
          servers: {
            'com.widevine.alpha': get(drm, 'widevine'),
            'com.microsoft.playready': get(drm, 'playready'),
            'com.apple.fairplay': get(drm, 'fairplay')
          }
        }
      });
    }

    player.addEventListener('error', this.onErrorEvent);

    // UI
    const uiConfig = this.configUIButtons(isPreRoll)

    const ui = new shaka.ui.Overlay(player, videoContainerRef, videoRef);
    ui.configure(uiConfig);

    this.ui = ui;

    const {subtitles} = this.props
    const {autoPlay} = this.state

    try {
      let manifestUri = '';
      if (video.hls && isIOSDevice()) {
        manifestUri = video.hls;
      } else if (video.dash) {
        manifestUri = video.dash;
      } else if (video.url) {
        manifestUri = video.url+"?v=shaka";
      }

      await player.load(manifestUri);

      this.player = player;

      if (video.dash) {
        await this.addSubtitles(player, subtitles);
      }

      if (autoPlay) {
        videoRef.play();
      }

    } catch (error) {
      this.onError(error);
    } finally {
      if (!isPreRoll) {
        const castProxy = new shaka.cast.CastProxy(videoRef, player, this.castReceiverId);
        this.castProxy = castProxy;
        window.castProxy = castProxy;
      }
    }
  };

  configUIButtons = (isPreRoll) => {
    const uiConfig = {
      addBigPlayButton: true,
    };
    if (isPreRoll) {
      uiConfig['controlPanelElements'] = ['mute', 'volume', 'time_and_duration'];
      uiConfig['addSeekBar'] = false;
      uiConfig['doubleClickForFullscreen'] = false;
      uiConfig['enableKeyboardPlaybackControls'] = false;
    } else {
      uiConfig['controlPanelElements'] = ['mute', 'volume', 'time_and_duration', 'fullscreen', 'overflow_menu'];
      uiConfig['overflowMenuButtons'] = [ 'captions', 'quality', 'picture_in_picture', 'cast'];
      uiConfig['addSeekBar'] = true;
      uiConfig['castReceiverAppId'] = this.castReceiverId;
    }

    if (isMobileDevice()) {
      uiConfig['doubleClickForFullscreen'] = false;
      uiConfig['enableFullscreenOnRotation'] = true;
    }

    return uiConfig;
  }

  addSubtitles = async (player, subtitles) => {
    for (let i = 0; i < subtitles.length; i++) {
      const subtitle = subtitles[i];
      await player.addTextTrack(subtitle.binary.url, subtitle.language, 'subtitle', subtitle.binary.mime_type, '', makeSubtitlesLabel(subtitle.language));
    }
  }

  onPlay = () => {
    if (isMobileDevice() && this.videoRef.clientWidth < window.screen.width) {
      document.getElementsByClassName('shaka-fullscreen-button')[0].click();
    }

    const {trackedPlay} = this.state;

    if (!trackedPlay) {
      this.props.setAutoPlay(true);
      GAevent('Contenido', "Play", this.props.videoTitle);
      this.setState({trackedPlay: true});
    }
  }

  onPreRollVideoEnded = async () => {
    const {video, setShowPreRoll} = this.props;

    if (setShowPreRoll) {
      setShowPreRoll(false);
    }

    await this.ui.getControls().destroy();

    this.setState({
      preRollVideo: false,
      autoPlay: true
    }, async () => {
      await this.initPlayer({video});
    });
  }

  render = () => {
    let {thumbnail} = this.props;
    const {preRollVideo} = this.state;

    if (thumbnail) {
      thumbnail = `${thumbnail}${thumbnail.includes('?') ? '&' : '?'}origin=shaka`;
    }

    if (preRollVideo) {
      return (
        <div
          ref={ref => this.preRollVideoContainerRef = ref}
          style={this.props.styles}
        >
          <video
            className="shaka-video"
            ref={ref => this.preRollVideoRef = ref}
            poster={thumbnail}
            crossOrigin="anonymous"
            onContextMenuCapture={(event) => {event.preventDefault(); return false}}
            onEnded={this.onPreRollVideoEnded}
          />
        </div>
      )
    }

    return(
      <div
        ref={ref => this.videoContainerRef = ref}
        style={this.props.styles}
      >
        <video
          className="shaka-video"
          ref={ref => this.videoRef = ref}
          poster={thumbnail}
          crossOrigin="anonymous"
          onContextMenuCapture={(event) => {event.preventDefault(); return false}}
          onPlay={this.onPlay}
        />
      </div>
    );
  }
}

export default ShakaPlayer